import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=2bf8c0da&scoped=true&"
import script from "./myorder.vue?vue&type=script&lang=js&"
export * from "./myorder.vue?vue&type=script&lang=js&"
import style0 from "./myorder.vue?vue&type=style&index=0&id=2bf8c0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8c0da",
  null
  
)

export default component.exports